module.exports = __webpack_public_path__ + "static/img/1_1_3_1.fcf281d4.jpg";